import { normalizeSystemRole, normalizeSystemRoles } from '@/utils/systemRoles';

export const DRIVERS_ROLE_CODES = ['c_level', 'admin', 'hr', 'recruiter'];

export function isDriversRole(roles) {
  const normalized = normalizeSystemRoles(roles);
  return normalized.some((code) => DRIVERS_ROLE_CODES.includes(code));
}

export function isDriversAdmin(roles) {
  const normalized = normalizeSystemRoles(roles);
  return normalized.includes('admin');
}

export function getPrimaryDriversRole(roles) {
  const normalized = normalizeSystemRoles(roles);
  const priority = ['admin', 'c_level', 'hr', 'recruiter'];
  for (const code of priority) {
    if (normalized.includes(code)) return code;
  }
  return normalized.find((code) => DRIVERS_ROLE_CODES.includes(code)) || null;
}

export const DRIVERS_DEFAULT_ROUTE_BY_ROLE = {
  c_level: 'dashboard',
  admin: 'dashboard',
  hr: 'active',
  recruiter: 'potential'
};

export function getDriversDefaultRouteName(roles) {
  const primary = getPrimaryDriversRole(roles);
  if (!primary) return null;
  return DRIVERS_DEFAULT_ROUTE_BY_ROLE[primary] || 'dashboard';
}

export function formatDriversRoleLabel(role) {
  const code = normalizeSystemRole(role);
  const labels = {
    c_level: 'C-Level',
    admin: 'Admin',
    hr: 'HR',
    recruiter: 'Recruiter'
  };
  return labels[code] || code;
}
